import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  createTraininghistory,
  getTraininghistoryById,
  updateTraininghistory,
} from '../../../../services/TraininghistoryService';
import { connect, useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import Swal from 'sweetalert2';
import { getUsersSearch } from '../../../../services/BoxService';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { getCourseTypesList } from '../../../../services/CourseTypeService';

const validationSchema = Yup.object().shape({
  employeeName: Yup.object().required('Employee Name Required'),
  employeeNumber: Yup.string().required('Employee Number Required'),
  date: Yup.date().required('Date Required'),
  phoneNumber: Yup.string().required('Contact Number Required'),
  chargeCode: Yup.string().required('Charge Code Required'),
  courseType: Yup.string().required('Course Type Required'),
  program: Yup.string().required('Program Name Required'),
  educationalBackground: Yup.string().required('Educatinal Background Required'),
  nameOfTrainingProgram: Yup.string().required('Name of Training Required'),
  location: Yup.string().required('Location Required'),
  descriptionOfTrainingProgram: Yup.string().required('Desription Required'),
  trainingStart: Yup.date().required('Start Date Required'),
  trainingEnds: Yup.date()
    .min(Yup.ref('trainingStart'), 'End date must be after start date')
    .required('Training Ends Date Required'),
  trainingCost: Yup.number(),
  trainingJustification: Yup.string().required('Training Justification Required'),
  customCourse: Yup.string().test(
    'required-if-other',
    'Please enter a course type',
    function (value) {
      return this.parent.courseType === 'other' ? !!value : true;
    }
  ),
  isApproved: Yup.string()
    .trim()
    .oneOf(['true', 'false'], 'Approval must be either true or false')
    .default('true'),
});

const EditTraininghistoryForm = ({ employeeList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [courseTypeList, setCourseTypeList] = useState([]);
  const [initialValues, setInitialValues] = useState({
    employeeName: '',
    employeeNumber: '',
    employeeEmail: '',
    date: moment().format('MM/DD/YYYY'),
    phoneNumber: '',
    chargeCode: '',
    courseType: '',
    customCourse: '',
    program: '',
    educationalBackground: '',
    nameOfTrainingProgram: '',
    location: '',
    descriptionOfTrainingProgram: '',
    trainingStart: '',
    trainingEnds: '',
    trainingCost: '',
    trainingJustification: '',
    manager: '',
    isApproved: 'true', // Default value as per schema
  });
  const chargeCodeList = [
    {
      label: 'FRNGE.105.06.MGR.001 Training - Corp/Infrastru HR',
      value: 'FRNGE.105.06.MGR.001 Training - Corp/Infrastru HR',
    },
    {
      label: 'FRNGE.105.06.MGR.002 Training - Ray Baldon - CTO',
      value: 'FRNGE.105.06.MGR.002 Training - Ray Baldon - CTO',
    },
    {
      label: 'FRNGE.105.06.MGR.003 Training - Susan Howell - SAMDA',
      value: 'FRNGE.105.06.MGR.003 Training - Susan Howell - SAMDA',
    },
    {
      label: 'FRNGE.105.06.MGR.004 Training - Paola Contreras Marroquin - Contracts',
      value: 'FRNGE.105.06.MGR.004 Training - Paola Contreras Marroquin - Contracts',
    },
    {
      label: 'FRNGE.105.06.MGR.005 Training - Belay Ademu - Accounting',
      value: 'FRNGE.105.06.MGR.005 Training - Belay Ademu - Accounting',
    },
    {
      label: 'FRNGE.105.06.MGR.006 Training - Rachit Mahajan - CFO',
      value: 'FRNGE.105.06.MGR.006 Training - Rachit Mahajan - CFO',
    },
    {
      label: 'FRNGE.105.06.MGR.007 Training - VACANT',
      value: 'FRNGE.105.06.MGR.007 Training - VACANT',
    },
    {
      label: 'FRNGE.105.06.MGR.008 Training - Terrance Sumter - Facilities',
      value: 'FRNGE.105.06.MGR.008 Training - Terrance Sumter - Facilities',
    },
    {
      label: 'FRNGE.105.06.MGR.009 Training - VACANT',
      value: 'FRNGE.105.06.MGR.009 Training - VACANT',
    },
    {
      label: 'FRNGE.105.06.MGR.010 Training - David McBride - COO',
      value: 'FRNGE.105.06.MGR.010 Training - David McBride - COO',
    },
    {
      label: 'FRNGE.105.06.MGR.011 Training - Oreste Reale - Grants',
      value: 'FRNGE.105.06.MGR.011 Training - Oreste Reale - Grants',
    },
    {
      label: 'FRNGE.105.06.MGR.012 Training - Susan Howell - HBG',
      value: 'FRNGE.105.06.MGR.012 Training - Susan Howell - HBG',
    },
    {
      label: 'FRNGE.105.06.MGR.013 Training - VACANT',
      value: 'FRNGE.105.06.MGR.013 Training - VACANT',
    },
    {
      label: 'FRNGE.105.06.MGR.014 Training - Chris Williamson - CSO',
      value: 'FRNGE.105.06.MGR.014 Training - Chris Williamson - CSO',
    },
    {
      label: 'FRNGE.105.06.MGR.015 Training - David McBride - ESES',
      value: 'FRNGE.105.06.MGR.015 Training - David McBride - ESES',
    },
    {
      label: 'FRNGE.105.06.OTH.001 Tuition & Training',
      value: 'FRNGE.105.06.OTH.001 Tuition & Training',
    },
  ];

  useEffect(() => {
    const getData = async () => {
      const response = await getTraininghistoryById(id);
      setInitialValues({
        ...response,
        date: moment(response.date).format('YYYY-MM-DD'), // Ensure correct formatting
        trainingStart: moment(response.trainingStart).format('YYYY-MM-DD'),
        trainingEnds: moment(response.trainingEnds).format('YYYY-MM-DD'),
      });
      setSelectedEmployee({
        value: response.employeeName,
        label: response.employeeName,
        email: response.employeeEmail,
        employeeNumber: response.employeeNumber,
      });
    };
    getData();
  }, [id]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  useEffect(() => {
    const fetchCourseType = async () => {
      const response = await getCourseTypesList();
      response.push({ label: 'Other', value: 'other' });
      setCourseTypeList(response);
    };
    fetchCourseType();
  }, []);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleSubmit = async (values) => {
    // Send the form data to the server
    try {
      await updateTraininghistory(id, {
        employeeName: values.employeeName.label,
        employeeNumber: values.employeeNumber,
        employeeEmail: values.employeeEmail,
        date: values.date,
        phoneNumber: values.phoneNumber,
        chargeCode: values.chargeCode,
        courseType: values.courseType,
        customCourse: values.customCourse,
        program: values.program,
        educationalBackground: values.educationalBackground,
        nameOfTrainingProgram: values.nameOfTrainingProgram,
        location: values.location,
        descriptionOfTrainingProgram: values.descriptionOfTrainingProgram,
        trainingStart: values.trainingStart,
        trainingEnds: values.trainingEnds,
        trainingCost: values.trainingCost,
        trainingJustification: values.trainingJustification,
        manager: values.manager,
        isApproved: values.isApproved,
      });
      // Show success toast notification
      toast.success('Training History update Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/traininghistory');
      }, 3000);
      console.log('Training history update successfully');

      // Optionally, redirect or update state after successful add
    } catch (error) {
      console.error('Error updating traininghistory:', error);
      toast.error('Failed to updating Training history!', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: false,
      });
    }
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue) => {
    setFieldValue(`employeeName`, selectedOption);
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`employeeEmail`, selectedOption.email);
  };

  return (
    <>
      <Card>
        <div className="card-body">
          <Row>
            <Col md={12}>
              <h4>Edit Training History</h4>
              <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                onSubmit={handleSubmit}
              >
                {({ values, setFieldValue, isSubmitting }) => (
                  <FormikForm>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="employeeName">Employee Name</label>
                          <AsyncSelect
                            name="employeeName"
                            loadOptions={loadOptions}
                            defaultOptions={employeeList}
                            placeholder="Select Employee Name"
                            isSearchable
                            onChange={(selectedOption) =>
                              handleEmployeeChange(selectedOption, setFieldValue)
                            }
                            value={selectedEmployee}
                          />
                          <ErrorMessage
                            name="employeeName"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="employeeNumber">Employee Number</label>
                          <Field
                            type="text"
                            name="employeeNumber"
                            className="form-control"
                            placeholder="Employee Number"
                            value={values.employeeNumber}
                            readOnly
                          />
                          <ErrorMessage
                            name="employeeNumber"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="date">Date</label>
                          <DatePicker
                            onChange={(date) => {
                              setFieldValue('date', date);
                            }}
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="MM/DD/YYYY"
                            value={values.date}
                          />
                          <ErrorMessage name="date" component="div" className="text-danger" />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="phoneNumber">Phone Number</label>
                          <Field
                            type="text"
                            name="phoneNumber"
                            className="form-control"
                            placeholder="123-456-7890"
                            value={values.phoneNumber}
                          />
                          <ErrorMessage
                            name="phoneNumber"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="chargeCode">Charge Code</label>
                          <Select
                            name="chargeCode"
                            options={chargeCodeList}
                            placeholder="Select Charge Code"
                            isSearchable
                            onChange={(selectedOption) =>
                              setFieldValue('chargeCode', selectedOption.label)
                            }
                            value={chargeCodeList.filter((e) => values.chargeCode == e.value)}
                          />
                          <ErrorMessage name="chargeCode" component="div" className="text-danger" />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="courseType">Course Type</label>
                          <Select
                            name="courseType"
                            options={courseTypeList}
                            placeholder="Select Course Type"
                            isSearchable
                            onChange={(selectedOption) => {
                              setFieldValue('courseType', selectedOption.value);
                              if (selectedOption.value === 'other') {
                                setFieldValue('customCourse', ''); // Reset custom field
                              }
                            }}
                            value={courseTypeList.filter((e) => values.courseType == e.value)}
                          />
                          <ErrorMessage name="courseType" component="div" className="text-danger" />
                        </div>
                      </Col>
                      {values.courseType === 'other' && (
                        <Col>
                          <div className="form-group">
                            <label htmlFor="customCourse">Other Course Type</label>
                            <Field
                              type="text"
                              name="customCourse"
                              className="form-control"
                              placeholder="Enter course type"
                              value={values.customCourse}
                            />
                            <ErrorMessage
                              name="customCourse"
                              component="div"
                              className="text-danger"
                            />
                          </div>
                        </Col>
                      )}
                      <Col>
                        <div className="form-group">
                          <label htmlFor="program">Program / Department</label>
                          <Field
                            type="text"
                            name="program"
                            className="form-control"
                            placeholder="Program / Department"
                            value={values.program}
                          />
                          <ErrorMessage name="program" component="div" className="text-danger" />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="educationalBackground">Educational Background</label>
                          <Field
                            as="textarea"
                            name="educationalBackground"
                            className="form-control"
                            placeholder="Educational Background"
                            value={values.educationalBackground}
                          />
                          <ErrorMessage
                            name="educationalBackground"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="nameOfTrainingProgram">Name of Training Program</label>
                          <Field
                            type="text"
                            name="nameOfTrainingProgram"
                            className="form-control"
                            placeholder="Name of Training Program"
                            value={values.nameOfTrainingProgram}
                          />
                          <ErrorMessage
                            name="nameOfTrainingProgram"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="location">Location / Institution Name</label>
                          <Field
                            type="text"
                            name="location"
                            className="form-control"
                            placeholder="Location/Institution name"
                            value={values.location}
                          />
                          <ErrorMessage name="location" component="div" className="text-danger" />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="descriptionOfTrainingProgram">
                            Description of Training Program
                          </label>
                          <Field
                            as="textarea"
                            name="descriptionOfTrainingProgram"
                            className="form-control"
                            placeholder="Description of Training Program"
                            value={values.descriptionOfTrainingProgram}
                          />
                          <ErrorMessage
                            name="descriptionOfTrainingProgram"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="trainingJustification">Training Justification</label>
                          <Field
                            as="textarea"
                            name="trainingJustification"
                            className="form-control"
                            placeholder="Training Justification"
                            value={values.trainingJustification}
                          />
                          <ErrorMessage
                            name="trainingJustification"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="trainingStart">Training Start</label>
                          <DatePicker
                            value={values.trainingStart}
                            onChange={(trainingStart) => {
                              setFieldValue('trainingStart', trainingStart);
                            }}
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="MM/DD/YYYY"
                          />
                          <ErrorMessage
                            name="trainingStart"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="trainingEnds">Training Ends</label>
                          <DatePicker
                            value={values.trainingEnds}
                            onChange={(trainingEnds) => {
                              setFieldValue('trainingEnds', trainingEnds);
                            }}
                            className="form-control"
                            dateFormat="MM/dd/yyyy"
                            placeholderText="MM/DD/YYYY"
                          />
                          <ErrorMessage
                            name="trainingEnds"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="trainingCost">Training Cost ($)</label>
                          <div className="input-group">
                            <span className="input-group-text">$</span>
                            <Field
                              type="number"
                              name="trainingCost"
                              className="form-control"
                              placeholder="Training Cost"
                              min="0"
                              step="1"
                              value={values.trainingCost}
                            />
                          </div>
                          <ErrorMessage
                            name="trainingCost"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                      <Col>
                        <div className="form-group">
                          <label htmlFor="trainingCost">Is Approved</label>

                          <Select
                            name="isApproved"
                            options={[
                              { label: 'Approved', value: 'true' },
                              { label: 'Rejected', value: 'false' },
                            ]}
                            placeholder="Select Status"
                            isSearchable={false}
                            onChange={(selectedOption) =>
                              setFieldValue('isApproved', selectedOption.value)
                            }
                            value={[
                              {
                                label: 'Approved',
                                value: 'true',
                              },
                              {
                                label: 'Rejected',
                                value: 'false',
                              },
                            ].filter((e) => values.isApproved == e.value)}
                          />

                          <ErrorMessage
                            name="trainingCost"
                            component="div"
                            className="text-danger"
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="d-flex justify-content-end">
                      <Button variant="primary" type="submit">
                        Update
                      </Button>
                    </div>
                  </FormikForm>
                )}
              </Formik>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(EditTraininghistoryForm);
